import createOrmSelector from 'redux/utils/createOrmSelector';

export default createOrmSelector(
  (session) => {
    const { Genotype } = session;

    return Genotype
      .all()
      .toRefArray()
      .map(item => ({
        label: item.custom_наименование,
        value: item.key,
      }));
  },
);
